module.exports = __webpack_public_path__ + "img/newswiper_8.a0183db4.png";